/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './ActionTypes';

const initialState = {
  hcpcsCodeClaimSearchObj: {},
  errorMsgHcpcsCode: [],
  planType: [],
  quarter: '',
  startQtr: '',
  endQtr: '',
  selectedRowIndexValue: [],
  exportToAllList: [],
  selectedOption: 'Detail',
  sortBy: 'Quarter',
  rebateProgram: [],
  allManufacturer: [],
  detailQtrSearchData: [],
  detailNdcSearchData: [],
  summaryQtrSearchData: [],
  summaryMfgSearchData: [],
  isLoading: false,
  manufacturerList: [],
  rebateProgramName: '',
  isMfgChecked: true,
  displayObj: {
    selectedOption: 'Detail',
    sortBy: 'Quarter',
    isMfgChecked: true,
    startQtr: '',
    endQtr: '',
    countValue: 1,
    rebateProgramName: '',
    allManufacturer: [],
    manufactureWithIds: [],
    rebateProgram: [],
    detailQtrSearchData: [],
    detailNdcSearchData: [],
    summaryQtrSearchData: [],
    summaryMfgSearchData: [],
    rebateProgrameName: '',
  },
  // checked: true,
};

const reducer = (state = initialState, Action) => {
  switch (Action.type) {
    case ActionTypes.GET_HCPCS_CODE_CLAIM_SEARCH_OBJ:
      return { ...state, hcpcsCodeClaimSearchObj: Action.screenData };
    // case ActionTypes.IS_LOADING:
    //   return { ...state, isLoading: Action.isLoading };
    case ActionTypes.GET_ERROR_MSG_HCPCS_CODE:
      return { ...state, errorMsgHcpcsCode: Action.payload };
    case ActionTypes.SELECT_OPTION:
      return { ...state, selectedOption: Action.payload };
    case ActionTypes.GET_MANUFACTURER_NAME_ACT:
      return { ...state, allManufacturer: Action.allManufacturer };
    case ActionTypes.DISPATCH_ALL_MFG_CHECKED:
      return { ...state, isMfgChecked: Action.payload };
    case ActionTypes.GET_MANUFACTURER_ID_ACT:
      return { ...state, manufactureWithIds: Action.manufactureWithIds };
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: Action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM:
    //   return { ...state, rebateProgram: Action.payload };
    case ActionTypes.SET_MANUFACTURERS_LIST:
      //return { ...state, manufacturerList: Action.payload };
      return {
        ...state,
        manufacturerList: Action.payload
          .slice()
          .sort((a, b) => a.mfgId - b.mfgId),
      };
    case ActionTypes.SET_DETAIL_REPORT_TYPE_QUARTER:
      let displayObj = {
        ...state.displayObj,
        detailQtrSearchData: Action.payload,
      };
      return { ...state, detailQtrSearchData: Action.payload, displayObj };
    case ActionTypes.SET_DETAIL_REPORT_TYPE_NDC:
      let displayObj1 = {
        ...state.displayObj,
        detailNdcSearchData: Action.payload,
      };
      return {
        ...state,
        detailNdcSearchData: Action.payload,
        displayObj: displayObj1,
      };
    case ActionTypes.SET_SUMMARY_REPORT_TYPE_QUARTER:
      let displayObj2 = {
        ...state.displayObj,
        summaryQtrSearchData: Action.payload,
      };
      return {
        ...state,
        summaryQtrSearchData: Action.payload,
        displayObj: displayObj2,
      };
    case ActionTypes.SET_SUMMARY_REPORT_TYPE_MANUFACTURER:
      let displayObj3 = {
        ...state.displayObj,
        summaryMfgSearchData: Action.payload,
      };
      return {
        ...state,
        summaryMfgSearchData: Action.payload,
        displayObj: displayObj3,
      };
    case ActionTypes.DISPLAY_SORT_BY:
      return { ...state, sortBy: Action.payload };
    case ActionTypes.DISPATCH_QTR_RANGE:
      return { ...state, ...Action.payload };
    case ActionTypes.SET_SELECTED_RESULT_HCPCS:
      return { ...state, ...Action.payload };

    case ActionTypes.SET_DISPLAY_OBJ_HCPCS_CLAIMS:
      return { ...state, ...Action.payload };
    case ActionTypes.REFRESH_HCPCS_CODE_CLAIMS:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };

    case ActionTypes.EXPORT_TO_ALL_DATA:
      return { ...state, exportToAllList: Action.exportToAllList };

    case ActionTypes.REFRESH_HCPCS_CODE_CLAIMS_DISPLAY:
      return {
        ...state,
        displayObj: {},
        // displayObj: state.displayObj,
      };
    case ActionTypes.SET_PAGINATION_INDEX_HCPCS_CLAIMS:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: Action.payload },
      };
    default:
      return state;
  }
};

export default reducer;
